import {
  ComplianceCaseStatus,
  ComplianceCaseTypeEnum as CaseType,
} from "~/graphql/supergraphEnums";
import { ComplianceCase } from "~/pages/Compliance/types";

export const allowDeleteEscalation = (
  complianceCase?: ComplianceCase,
  assigneeRole?: "maker" | "checker",
) => {
  if (!complianceCase) return false;
  if (!assigneeRole || assigneeRole === "checker") return false;
  switch (complianceCase.caseType) {
    case CaseType.InvestorOnboarding:
      return complianceCase.status === ComplianceCaseStatus.InProgress;
    case CaseType.RecurringHit:
      return complianceCase.status === ComplianceCaseStatus.InProgress;
    case CaseType.PaymentInstructionChangeReview:
      return complianceCase.status === ComplianceCaseStatus.InProgress;
    case CaseType.Remediation:
      return complianceCase.status === ComplianceCaseStatus.InProgress;
    case CaseType.ChangeInCircumstance:
      return complianceCase.status === ComplianceCaseStatus.InProgress;
    case CaseType.DocumentRefresh:
      return complianceCase.status === ComplianceCaseStatus.InProgress;
    case CaseType.ProfileRefresh:
      return complianceCase.status === ComplianceCaseStatus.InProgress;
    default:
      return false;
  }
};
